import React from "react";
import styles from "./SlowLoader.module.scss";
import slowLoader from "src/assets/slow-loader.svg";

export const SlowLoader = (): JSX.Element => {
	return (
		<img className={styles.slowLoader} src={slowLoader} />
	);
};
